type iconObject = {
  [key: string]: string;
};

const allIcons: iconObject = {
  arrow: "arrow.svg",
  location: "location.svg",
  star: "star.svg",
  nearest: "nearest.svg",
  exit: "exit.svg",
  newest: "newest.svg",
  info: "info.svg",
  "arrow-down": "arrow-down.svg",
};

export default allIcons;
